import { WebshopProduct } from '@cldsystems/ws-api-client';
import { SortByItemKeys } from '@/types/common/sort-by-item-keys';
import { paginateProducts, sortProducts } from '@/utils/filtered-products';
import { selectMainImage } from '@/utils/select-main-image';

/** Must match `selectMainImage` params in `product-card-listing.tsx`. */
export const PRODUCT_CARD_IMAGE_PARAMS = { width: 440, quality: 75 } as const;

/**
 * Sizes hint for the product grid: 2 cols mobile, 3–4 cols desktop.
 * Used by `<link rel="preload" imageSizes="…">` on listing pages.
 */
export const PRODUCT_LISTING_LCP_IMAGE_SIZES =
  '(min-width: 1280px) 25vw, (min-width: 1024px) 33vw, (min-width: 768px) 33vw, 50vw';

const LISTING_PAGE_SIZE = 25;

/**
 * Returns the Gumlet URL for the LCP product image on page 1 (default sort).
 * Only one preload should be emitted — Next/React will handle priority on the `<img>`.
 */
export function getProductListingLcpPreloadHref(products: WebshopProduct[]): string | undefined {
  const sorted = sortProducts(products, SortByItemKeys.NONE);
  const { paginatedProducts } = paginateProducts(sorted, 1, LISTING_PAGE_SIZE);
  const first = paginatedProducts[0];
  if (!first) return undefined;
  return selectMainImage(first.images ?? [], PRODUCT_CARD_IMAGE_PARAMS) || undefined;
}

/** @deprecated Prefer {@link getProductListingLcpPreloadHref} — multiple preloads hurt LCP. */
export function getProductListingLcpPreloadHrefs(products: WebshopProduct[]): string[] {
  const href = getProductListingLcpPreloadHref(products);
  return href ? [href] : [];
}
